/// This class is responsible for taking input json,
/// extracting keys based on the JsonMappingSchema, and
/// then outputting the final JSON.
///
/// This is intended to be used with dynamic types.

type JsonMappingSchema = {
  sourceField: string;
  targetField: string;
};

function flattenJson(input: any, schema: JsonMappingSchema[]): Record<string, any> {
  const output: Record<string, any> = {};
  schema.forEach(({ sourceField, targetField }) => {
    const value = getNestedValue(input, sourceField);
    if (value !== undefined) {
      output[targetField] = value;
    }
  });

  return output;
}

export function getNestedValue(obj: any, path: string): any {
  const keys = path
    .replace(/\[(\d+)]/g, '.$1')
    .split('.');
  return keys.reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}
